import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    headline: 'From Sticky to Smooth',
    text: 'I wasted over $200 on resin before finding this. My first pour after Day 2 was perfect.',
    author: 'Sarah M.',
    location: 'Toronto, Canada'
  }, {
    headline: 'Finally Selling on Etsy',
    text: 'I was too afraid to sell because of bubbles. Now my pieces are crystal clear and I made my first 5 sales!',
    author: 'Jessica K.',
    location: 'Austin, USA'
  }, {
    headline: 'No More Guessing',
    text: 'The diagnostic checklist is a lifesaver. I know exactly what to do before I even mix.',
    author: 'Amanda R.',
    location: 'Sydney, Australia'
  }];
  return <section className="py-20 bg-[#FDFCF8]" data-id="element-136">
      <div className="container mx-auto px-4" data-id="element-137">
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-138">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-139">
              <div className="flex gap-1 mb-4" data-id="element-140">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-orange-400 fill-current" data-id="element-141" />)}
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-142">
                {t.headline}
              </h3>
              <p className="text-stone-600 mb-6 leading-relaxed" data-id="element-143">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-144">
                <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center text-stone-500 font-bold" data-id="element-145">
                  {t.author[0]}
                </div>
                <div data-id="element-146">
                  <div className="font-bold text-stone-900 text-sm" data-id="element-147">
                    {t.author}
                  </div>
                  <div className="text-xs text-stone-400" data-id="element-148">{t.location}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}